/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { map } from 'lodash';
import { func } from 'prop-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import type { ActionContext } from 'js/lib/ActionContext';

import SurveyQuestion from 'bundles/university-program-qualification/components/SurveyQuestion';
import type ProgramQualificationStoreType from 'bundles/university-program-qualification/store/ProgramQualificationStore';

const styles = {
  surveySection: css`
    margin-top: 4px;

    .section-questions {
      margin-top: 20px;
      flex-wrap: wrap;
    }

    .section-title {
      margin-bottom: 20px;
    }

    .section-buttons {
      margin-top: 10px;
    }

    .cancel-button {
      margin-right: 10px;
    }

    .submit-button {
      margin-left: 10px;
    }
  `,
};

export type PropsFromCaller = {
  sectionData: $TSFixMe;
  slug: string;
};

export type PropsFromStore = {
  responseValidation: $TSFixMe;
};

export type Stores = {
  ProgramQualificationStore: typeof ProgramQualificationStoreType;
};

export type Props = PropsFromCaller & PropsFromStore;

type LegacyContext = {
  executeAction: ActionContext['executeAction'];
};

const SurveySection: React.FC<Props> = ({ sectionData, responseValidation, slug }, context: LegacyContext) => {
  if (!sectionData) {
    return <div className="section-title headline-5-text">Loading...</div>;
  }

  const { questions } = sectionData;

  // Filter out emailAddress and isEmailProvided for student upswell page
  let visibleQuestions = questions;
  if (slug === 'for-university-and-college-students')
    visibleQuestions = questions.filter(
      (questionData: $TSFixMe) => questionData.id !== 'emailAddress' && questionData.id !== 'isEmailProvided'
    );

  return (
    <div className="rc-SurveySection" css={styles.surveySection}>
      <div className="section-questions horizontal-box">
        {map(visibleQuestions, (question) => {
          const questionId = question.id;
          return (
            <SurveyQuestion questionData={question} key={questionId} validationError={responseValidation[questionId]} />
          );
        })}
        <input className="eoi_ga_tracking" type="hidden" id="clientid" name="ga_clientid" />
        <input className="eoi_ga_tracking" type="hidden" id="enterpriseclientid" name="ga_enterpriseclientid" />
      </div>
    </div>
  );
};

SurveyQuestion.contextTypes = {
  executeAction: func.isRequired,
};

export default connectToStores<Props, PropsFromCaller, Stores>(
  SurveySection,
  ['ProgramQualificationStore'],
  ({ ProgramQualificationStore }) => {
    return {
      responseValidation: ProgramQualificationStore.getResponseValidation(),
    };
  }
);
